import React from "react";
import { Button, Icon } from "semantic-ui-react";
import { MozillaHubRoomsApi } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { ENV } from "../../../../Utils";
import "./RoomsItem.scss";

const roomsControllers = new MozillaHubRoomsApi();

export function RoomsItem(props) {
  const { accessToken } = useAuth();
  const { room, onReload } = props;

  const loadRoom = async () => {
    try {
      const sceneId = room.scene.id;
      const response = await roomsControllers.LoadRoom(accessToken, sceneId); // Asegurarse de enviar el sceneId como JSON

      console.log("Room cargado:", response);

      // Construye la URL para la nueva ventana
      const roomUrl = `${ENV.HUB_PATH}/${response.room.id}`;
      console.log("URL de la room:", roomUrl);

      // Abre una nueva ventana/pestaña y carga la URL en pantalla completa
      const newWindow = window.open(roomUrl, "_blank");
      if (newWindow) {
        newWindow.focus(); // Asegura que la ventana/pestaña esté enfocada
      }

      onReload();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="room-item">
      <span>{room.scene ? room.scene.id : "No Scene ID"}</span>
      <span>{room.scene ? room.scene.name : "No Scene Name"}</span>
      <div>
        <Button icon color="blue" onClick={loadRoom}>
          <Icon name="podcast" />
        </Button>
      </div>
    </div>
  );
}
